import React, { useState, useEffect } from "react";
import axiosClient from "../../config/axiosClient";
import API_ENDPOINTS from "../../config/api";
import DivisionModal from "./DivisionModal";
import "./DivisionList.css";

const PAGE_SIZE = 10;

const DivisionList = () => {
  const [divisions, setDivisions] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingDivision, setEditingDivision] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchDivisions();
    fetchDepartments();
  }, []);

  const fetchDivisions = async () => {
    try {
      const res = await axiosClient.get(API_ENDPOINTS.divisions);
      setDivisions(res.data || []);
    } catch (error) {
      console.error("❌ Lỗi load Divisions:", error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const res = await axiosClient.get(API_ENDPOINTS.departments);
      setDepartments(res.data || []);
    } catch (error) {
      console.error("❌ Lỗi load Departments:", error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this division?")) return;
    await axiosClient.delete(`${API_ENDPOINTS.divisions}/${id}`);
    fetchDivisions();
  };

  const handleSave = async (data) => {
    try {
      // Chuẩn hóa payload để gửi lên backend
      const payload = {
        id: data.id,
        name: data.name,
        departmentIds: data.selectedDepartments
      };

      if (editingDivision) {
        await axiosClient.put(
          `${API_ENDPOINTS.divisions}/${data.id}`,
          payload
        );
      } else {
        await axiosClient.post(API_ENDPOINTS.divisions, payload);
      }
      fetchDivisions();
      setShowModal(false);
    } catch (err) {
      console.error(err);
      alert("Error saving division!");
    }
  };

  const filtered = divisions.filter((d) =>
    (d.name || "").toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const currentData = filtered.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  const thStyle = {
    backgroundColor: "#f8f9fc",
    color: "#4e73df",
    fontWeight: "bold",
    fontSize: "0.8rem",
    textTransform: "uppercase",
  };

  return (
    <div className="container-fluid py-4">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white py-3 d-flex justify-content-between">
          <h5 className="m-0 fw-bold text-uppercase">Division Management</h5>

          <div className="d-flex gap-2">
            <input
              className="form-control form-control-sm"
              style={{ width: 200, borderRadius: 20 }}
              placeholder="Search..."
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
            <button
              className="btn btn-sm btn-primary rounded-pill"
              onClick={() => {
                setEditingDivision(null);
                setShowModal(true);
              }}
            >
              + Add
            </button>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th style={thStyle}>No</th>
                <th style={thStyle}>Division Name</th>
                <th style={thStyle}>Departments</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {currentData.map((d, i) => (
                <tr key={d.id}>
                  <td>{(currentPage - 1) * PAGE_SIZE + i + 1}</td>
                  <td className="fw-bold">{d.name}</td>
                  <td>
                    {d.departments && d.departments.length > 0 ? (
                      d.departments.map((dept) => (
                        <span key={dept.id} className="badge bg-info me-1">
                          {dept.name}
                        </span>
                      ))
                    ) : (
                      <span className="text-muted">No departments</span>
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => {
                        setEditingDivision(d);
                        setShowModal(true);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(d.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="p-3">
          Page {currentPage} / {totalPages || 1}
        </div>
      </div>

      {showModal && (
        <DivisionModal
          show={showModal}
          initialData={editingDivision}
          onClose={() => setShowModal(false)}
          onSave={handleSave}
          departments={departments}
        />
      )}
    </div>
  );
};

export default DivisionList;